<template>
  <div  class="app-container">
    <el-tabs v-model="activeName"  @tab-click="handleTabClick" >
      <el-tab-pane label="月成本汇总" name="one" style="">
        <yueChengBen v-if="activeName=='one'&&flag" :invoiceMark="1" :usertype="usertype" @tiaozhuan="tiaozhuanFn"></yueChengBen>
      </el-tab-pane>
      <el-tab-pane label="月承运商成本" name="two">
        <CYSyueChengBen v-if="activeName=='two'&&flag" :invoiceMark="1" :usertype="usertype" :businessDate="tiaozhuanData.businessDate"
        :createSubdepartmentCode="tiaozhuanData.createSubdepartmentCode"></CYSyueChengBen>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import yueChengBen from './zujian/yueChengBen'
import CYSyueChengBen from './zujian/CYSyueChengBen'
import { getBtn, getAttributeB } from '@/utils/getButton'
export default {
  components: {
    yueChengBen, CYSyueChengBen
  },
  data () {
    return {
      activeName: 'one',
      flag: false, // 拿到业务角色再显示
      usertype: 1, // 1.业务、审批人 2.财务
      tiaozhuanData: {}
    }
  },
  created () {
    getAttributeB('ARRTMSBusiness', 1).then(res => {
      if (res[0] == 1) { // crm返回 业务人员0、 财务人员1
        this.usertype = 2
      } else {
        this.usertype = 1
      }
      this.flag = true
    })
  },
  methods: {
    tiaozhuanFn (val) {
      this.activeName = 'two'
      this.tiaozhuanData = val
    },
    handleTabClick () {
      if (this.activeName == 'one') {
        this.tiaozhuanData = {
          businessDate: null, createSubdepartmentCode: null
        }
      }
    }
  }

}
</script>
<style scoped lang='less'>
/deep/.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
    background-color: #0c46a2 !important;
    color: #fff;
}
/deep/.el-tabs__header{
  margin-bottom: 0;
}
</style>
